
/*

The primary concern of this enum/exercise was to specify the sizing of complex
elements within an L2ControlGrid, which is the primary mechanism for laying out
elements on the form.

L1TextField began as a plain <input type="text" /> element with some sizing
rules that gave it explicit widths (min/medium/max), and also "stretch" and
"1fr" options that attempted to have the field consume available space.  These
all had hard to predict, less than ideal behaviors depending on which contexts
(flow/flex/grid) the element was thrown into and the CSS rules on their
parent containers.

In attempting to fix this a variety of layout tests were performed.
Main learnings were:

  * We don't really care how the elements size and behave in
    plain flow context since everything in this app is flex or grid
    (https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_flow_layout/Introduction_to_formatting_contexts)
	Although, conveniently, the L1TextField had a default "medium" size which
	will be retained for backwards-compatibility purposes, so it works out well
	there anyway.

  * We mostly care how the elements behave within the L2ControlGrid layouts,
	since pretty much everything on the form is in one of those, or some other
	similar type of flex/grid in custom components.

  * When using in a flex context (e.g. L2ControlGridLayout.FlexRow, .FlexColumn)
	a flex: '1 1 auto' rule can be applied ('FlexStretch' size) so that the
	element expands to take up available space in the row.

  * When using in a grid context, keep the intrinsic size of the complex
	element to a minimum ('Undefined' or 'Min' size), so that the element is
	less likely to push over the bounds of the grid columns, and instead rely
	on good grid-template-columns rules to size and line up the complex
	elements nicely.

*/

export enum ComplexElementSize {
	// allow element sizing to be as completely dictated as possible
	// by the containing grid or other context
	Undefined = 'undefined',

	// the minimum size the component should reasonably take on
	// in plain flow or flex context
	Min = 'min',

	// a reasonable default size for the component
	// in plain flow or flex context
	// (but not necessarily the component's default)
	Medium = 'medium',

	// the maximal size the component should reasonably take on
	// in plain flow or flex context
	Max = 'max',

	// for use within flex context only,
	// applies '1 1 auto' rule to consume available space
	FlexStretch = 'flexStretch',
}
